/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class CartPromotions {
  constructor (element) {
    this.$el = $(element)
    this.$carousel = this.$el.find('.cartPromotions-promotionsCarousel')

    this.$carousel.slick({
      dots: false,
      arrows: true,
      rows: 0, // https://github.com/kenwheeler/slick/issues/3149
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 897,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    })
      .on('setPosition', function () {
        const $slickslide = $(this)
        $slickslide.find('.slick-slide').height('auto')
        var slickTrack = $slickslide.find('.slick-track')
        var slickTrackHeight = $(slickTrack).height()
        $slickslide.find('.slick-slide').css('height', slickTrackHeight + 'px')
      })
  }
}

registerClass('CartPromotions', CartPromotions)
